import React from "react";
import PropTypes from "prop-types";
import Styles from "./atom-loading-button.module.scss";

class AtomLoadingButton extends React.Component {
  static propTypes = {
    additionalClassName: PropTypes.string,
    buttonText: PropTypes.string.isRequired,
    textWidth: PropTypes.string.isRequired,
  };

  getStyles() {
    return {
      width: this.props.textWidth,
    };
  }

  getAdditionalClassName() {
    return this.props?.additionalClassName ?? "";
  }

  render() {
    return (
      <button className={`btn ${this.getAdditionalClassName()}`} disabled={true}>
        <span className={`btn-loading ${Styles["btn-loading"]}`} style={this.getStyles()}>
          {this.props.buttonText}
        </span>
      </button>
    );
  }
}

export default AtomLoadingButton;
